import React from 'react';
import '../App.css';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, botName }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Delete Chatbot</h2>
        <p>Are you sure you want to delete "{botName}"? This action cannot be undone.</p>
        <div className="modal-buttons">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-button" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal; 